import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { fetchTemuProducttypeCategories } from '@/api/temuProducttypes/api'
import type { TemuProducttypeCategory } from '@/api/temuProducttypes/types'

const TEMU_PRODUCTTYPES_KEY = 'temu-producttype-categories' as const

export function useTemuProducttypes(): UseQueryResult<readonly TemuProducttypeCategory[]> {
  return useQuery({
    queryKey: [TEMU_PRODUCTTYPES_KEY],
    queryFn: ({ signal }) => fetchTemuProducttypeCategories(signal),
    refetchOnWindowFocus: false,
    staleTime: 60_000,
  })
}
